"use strict";
// For some reasons days of the week should start from sunday in react day picker
// https://react-day-picker.js.org/docs/localization/
Object.defineProperty(exports, "__esModule", { value: true });
exports.FR_WEEKDAYS_SHORT = exports.FR_WEEKDAYS_LONG = exports.FR_MONTHS = exports.DE_WEEKDAYS_SHORT = exports.DE_WEEKDAYS_LONG = exports.DE_MONTHS = void 0;
exports.DE_MONTHS = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
];
exports.DE_WEEKDAYS_LONG = [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
];
exports.DE_WEEKDAYS_SHORT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
exports.FR_MONTHS = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
];
exports.FR_WEEKDAYS_LONG = [
    'Dimanche',
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
];
exports.FR_WEEKDAYS_SHORT = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
//# sourceMappingURL=fdr-travel-dates.translations.js.map